"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileInputFileTypes;
(function (FileInputFileTypes) {
    FileInputFileTypes["Images"] = "image/*";
    FileInputFileTypes["All"] = "";
})(FileInputFileTypes || (FileInputFileTypes = {}));
exports.default = FileInputFileTypes;
